let store = null;

const _interceptors = {
  request: {
    onSuccess: function(config) {
      if (config.showSpinner) {
        store.commit("spinner/requestStart");
      }
      return config;
    },
    onReject: function(error) {
      return Promise.reject(error);
    }
  },
  response: {
    onSuccess: function(response) {
      if (response.config.showSpinner) {
        store.commit("spinner/requestStop");
      }
      return response;
    },
    onReject: function(error) {
      if (error.config.showSpinner) {
        store.commit("spinner/requestStop");
      }
      return Promise.reject(error);
    }
  }
};

export default {
  wrapAxios(axiosInstance) {
    axiosInstance.interceptors.request.use(_interceptors.request.onSuccess, _interceptors.request.onReject);
    axiosInstance.interceptors.response.use(_interceptors.response.onSuccess, _interceptors.response.onReject);
  },
  wrapStore(storeInstance) {
    store = storeInstance;
  }
};
